import { render, staticRenderFns } from "./AkinonFindNearestStock.vue?vue&type=template&id=3b5167e0"
import script from "./AkinonFindNearestStock.vue?vue&type=script&lang=js"
export * from "./AkinonFindNearestStock.vue?vue&type=script&lang=js"
import style0 from "./AkinonFindNearestStock.vue?vue&type=style&index=0&id=3b5167e0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports